"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const phaser_1 = __importDefault(require("phaser"));
const zimporter_phaser_1 = require("zimporter-phaser");
const Game_1 = require("./Game");
const config = {
    type: phaser_1.default.AUTO,
    width: window.innerWidth,
    height: window.innerHeight,
    backgroundColor: '#000000',
    parent: 'game-container',
    scene: [Game_1.Game],
    scale: {
        mode: phaser_1.default.Scale.RESIZE,
        autoCenter: phaser_1.default.Scale.CENTER_BOTH
    },
    plugins: {
        scene: [
            {
                key: 'SpinePlugin',
                plugin: zimporter_phaser_1.SpinePlugin,
                mapping: 'spine'
            }
        ]
    }
};
const game = new phaser_1.default.Game(config);
globalThis.__PHASER_GAME__ = game;
window.addEventListener('resize', () => {
    const scene = game.scene.getScene('GameScene');
    if (scene) {
        scene.resize(window.innerWidth, window.innerHeight);
    }
});
